import styled from 'styled-components';

const PaymentInformationWrapper = styled.div`
  display: block;
`;
const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0 0 16px 0;
  flex-direction: column;

  @media (min-width: 565px) {
    flex-direction: row;
  }
`;
const Label = styled.p`
  ${(props) => props.theme.font.subhead.v400};
  font-weight: 400;
  max-width: 250px;
  width: 100%;
  margin-bottom: 4px;
`;
const Value = styled.span`
  ${(props) => props.theme.font.subhead.v400};
  font-weight: ${(props) => props.theme.font.weight.v300};
  color: #183558;
`;

export { PaymentInformationWrapper, Row, Label, Value };
